<template>
  <div>
    <iframe
      id="player-frame"
      :src
      class="border-0 h-[calc(100vh-132px)] w-full"
      @load="() => onLoadFrame()"
    ></iframe>
  </div>
</template>

<script setup lang="ts">
import { onMounted, nextTick, ref, onUnmounted, toRaw } from 'vue'
import { useAuthStore } from '@/stores'

import scormAcompanhamento from '@/services/scormAcompanhamento.service'

const emit = defineEmits(['onUpdateProgress'])

const { mediaId, src = '', trackProgress = true } = defineProps<{
  mediaId?: string
  src: string
  trackProgress?: boolean
}>()

const listenOnMessage = ref(false)
const status = ref('')
const skipCommit = ref(false)

const resourceId = ref('')
const cmiDump = ref<Record<string, any> | string | null>(null)

let lastSuspendData = ''

const onMessage = (event) => {
  const { data: msgData } = event
  if (!msgData || !listenOnMessage.value) return

  const { func, data } = msgData
  if (!func) return

  if (func === 'LMSCommit') {
    if (['completed', 'passed'].includes(data.core.lesson_status))
      emit('onUpdateProgress', 100)
  } else if (func === 'Commit') {
    if (['completed', 'passed'].includes(data.completion_status))
      emit('onUpdateProgress', 100)
  }

  // Salva o progresso no backend
  if (['LMSCommit', 'Commit'].includes(func) && !skipCommit.value && resourceId.value && data?.suspend_data) {
    if (lastSuspendData !== data.suspend_data) {
      lastSuspendData = data.suspend_data
    } else {
      return
    }

    scormAcompanhamento.put('', {
      id: resourceId.value,
      userId: useAuthStore().persistentInfo?.id || '',
      suspendData: JSON.stringify(data)
    })
  }
}

const loadProgressScorm = async () => {
  status.value = 'loading'

  try {
    const { data }: { data: any } = await scormAcompanhamento.getProgressScorm(mediaId, {
      inscricaoId: null
    })

    if (!data) {
      // Como mídia solta
      const { data: progressCreated, success } = await scormAcompanhamento.post<any>('', {
        midiaId: mediaId,
        inscricaoId: null
      })

      if (success && progressCreated?.id) {
        resourceId.value = progressCreated.id
      } else {
        skipCommit.value = true
      }
    } else {
      resourceId.value = data.id

      // Verifica se suspend data (string) é um array de JSON, uma string simples ou null
      try {
        cmiDump.value = data.suspendData ? JSON.parse(data.suspendData) : null
      } catch {
        cmiDump.value = data.suspendData || null
      }
    }

    status.value = 'finish'
  } catch {
    status.value = 'error'
    skipCommit.value = true
  }
}

const onLoadFrame = async () => {
  if (trackProgress) {
    await loadProgressScorm()
  }

  const scormFrame = (document.getElementById('player-frame') as any)?.contentWindow
  if (scormFrame) {
    nextTick(() => {
      const user = useAuthStore().persistentInfo

      try {
        scormFrame.postMessage({
          func: 'start',
          data: toRaw(cmiDump.value) || null,
          user: {
            name: user?.fullName || '',
            nick: user?.name !== user?.fullName ? user?.name : '',
            role: user?.role || '',
            department: user?.department || '',
            unit: user?.unidade?.name || ''
          }
        }, '*')
      } catch (error) {
        console.error('Error posting start message to SCORM frame', error)
      }
    })
  }
}

onMounted(() => {
  nextTick(async () => {
    if (trackProgress) {
      listenOnMessage.value = true
      window.addEventListener('message', onMessage, false)
      src.includes('scormcontent') && trackProgress && emit('onUpdateProgress', 100)
    }
  })
})

onUnmounted(() => {
  window.removeEventListener('message', onMessage, false)
})
</script>